import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { ReportDiscountsService } from '../../services/report_discounts.service';
import { PeriodService } from '../../../periods/period.service';
import { UserService } from '../../../user/services/user.service';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-add-edit-discounts',
  templateUrl: './add-edit-discounts.component.html',
  styleUrl: './add-edit-discounts.component.scss'
})
export class AddEditDiscountsComponent {
  discountForm!: FormGroup;
  @Input() discountData: any;
  isEdit: boolean = false;
  selectedDiscountId: string = '';
  users: any[] = []
  periods: any[] = []
  currentYear: number = new Date().getFullYear();
  constructor(
    private fb: FormBuilder,
    private discountService: ReportDiscountsService,
    private periodService: PeriodService,
    private userService: UserService
  ) {
    this.discountForm = this.fb.group({
      userId: new FormControl('', Validators.required),
      periodId: new FormControl('', Validators.required),
      title: new FormControl('', Validators.required),
      description: new FormControl(''),
      vote: new FormControl(''),
      value: new FormControl('', Validators.required)
    })
  }

  ngOnInit() {
    // Cierra cualquier modal abierto antes de inicializar
    this.discountService.setCloseModal(true);

    this.loadUsers()
    this.loadPeriods()
    this.discountService.currentDiscount$.subscribe(discount => {
      if (discount) {
        this.isEdit = true;
        this.selectedDiscountId = discount._id;
        this.discountForm.patchValue({
          userId: discount.userId,
          periodId: discount.periodId,
          title: discount.title,
          description: discount.description,
          vote: discount.vote,
          value: discount.value
        });
      } else {
        this.isEdit = false;
        this.selectedDiscountId = '';
        this.discountForm.reset();
      }
    });

  }

  ngOnDestroy() {
    // Limpia el estado del modal al destruir el componente
    this.discountService.setCloseModal(true);
  }

  loadUsers() {
    this.userService.get(true).subscribe({
      next: (response) => {
        this.users = response.users;
      },
      error: (error) => {
        console.error('Error al cargar los usuarios:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo cargar los usuarios',
        });
      }
    })
  }

  loadPeriods() {
    this.periodService.get(this.currentYear, false).subscribe({
      next: (response) => {
        this.periods = response;
      },
      error: (error) => {
        console.error('Error al cargar los conceptos:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo cargar los conceptos',
        });
      }
    })
  }

  setCloseModal() {
    this.isEdit = false
    this.discountForm.reset({
      userId: '',
      periodId: '',
      title: '',
      description: '',
      vote: '',
      value: ''
    })
    this.discountService.setCloseModal(true)
  }
  saveDiscount() {
    if (this.discountForm.invalid) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Complete todos los datos para poder guardar',
      });
      return;
    }
    const discountData = this.discountForm.value;

    if (this.isEdit) {
      this.discountService.update(this.selectedDiscountId, discountData).subscribe(
        () => {
          this.setCloseModal()
          Swal.fire({
            icon: 'success',
            title: 'Actualización de Descuento',
            text: 'Descuento se ha actualizado correctamente'
          })
        },
        error => {
          console.error('Error al actualizar el descuento', error);
        }
      );
    } else {
      this.discountService.save(discountData).subscribe(
        () => {
          this.setCloseModal()

          Swal.fire({
            icon: 'success',
            title: 'Descuento añadido',
            text: 'Descuento se ha añadido correctamente'
          })
        },
        error => {
          console.error('Error al crear el descuento', error);
        }
      );
    }
  }

}
